export default {
  paper: {
    marginTop: 8,
    borderRadius: 8,
    '& .MuiMenu-list': {
      maxHeight: '100%',
    },
  },
};
